import service from '../../../../../services';

export default {
  /** Busca todos os Leads B2C
   * @return {Promise<Array<Object>>}
   */
  async getLeadsB2C() {
    try {
      const result = await service.getAll('LeadsB2C', {}, 'buscar-leads-b2c');
      return Promise.resolve(result.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
